import React, { useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { ArrowUpward, ArrowDownward, SwapVert } from "@mui/icons-material";

const MobileSortIcon = ({ benefitTypeId, sortState }) => {
  const isMobile = useMediaQuery("(max-width:1032px)");
  const { appliedConfiguration } = useContext(ConfigurationContext);

  const iconsSetting =
    appliedConfiguration?.coverageFinderSortingIconsSettings?.filter(
      (s) => s.benefitTypeId === benefitTypeId
    ) || [];

  const getIconData = (iconFunction) => {
    const match = iconsSetting.find(
      (icon) =>
        icon.iconFunction === iconFunction &&
        (isMobile ? icon.mobileIcon : icon.desktopIcon)
    );

    return {
      iconUrl: isMobile ? match?.mobileIcon : match?.desktopIcon,
      altText: isMobile ? match?.mobileAltText : match?.deskTopAltText,
    };
  };

  const iconFunctionMap = {
    0: "Default",
    1: "Ascending",
    2: "Descending",
  };

  const iconFunction = iconFunctionMap[sortState] || "Default";
  const iconData = getIconData(iconFunction);
  const hasValidIcon = iconData.iconUrl && iconData.iconUrl.trim() !== "";

  const renderCustomIcon = () => (
    <img
      part="cfAscSortIcon"
      className="norstella-cf-SortIcon"
      src={iconData.iconUrl}
      alt={iconData.altText || "sortIcon"}
    />
  );

  // Render based on sortState
  switch (sortState) {
    case 1:
      return (
        <>
          A-Z {hasValidIcon ? renderCustomIcon() : <ArrowUpward />}
        </>
      );
    case 2:
      return (
        <>
          Z-A {hasValidIcon ? renderCustomIcon() : <ArrowDownward />}
        </>
      );
    case 0:
    default:
      return hasValidIcon ? renderCustomIcon() : <SwapVert />;
  }
};

export default MobileSortIcon;
